var map = {
	"./alelo.svg": 4972,
	"./alipay.svg": 7239,
	"./american express.svg": 5203,
	"./amex.svg": 6456,
	"./aura.svg": 5812,
	"./code-front.svg": 5444,
	"./code.svg": 8042,
	"./diners.svg": 3214,
	"./discover.svg": 8508,
	"./elo.svg": 2377,
	"./generic-clean.svg": 9740,
	"./generic.svg": 7840,
	"./hiper.svg": 3625,
	"./hipercard.svg": 6631,
	"./jcb.svg": 6558,
	"./maestro.svg": 2496,
	"./mastercard.svg": 4829,
	"./mir.svg": 1815,
	"./paypal.svg": 5712,
	"./sodexo.svg": 9349,
	"./unionpay.svg": 2640,
	"./visa.svg": 582
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6263;